import { render, staticRenderFns } from "./ManageInfectionCases.vue?vue&type=template&id=034cb674&"
import script from "./ManageInfectionCases.vue?vue&type=script&lang=js&"
export * from "./ManageInfectionCases.vue?vue&type=script&lang=js&"
import style0 from "./ManageInfectionCases.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports